import { Helmet } from 'react-helmet-async';
import { CONFIG } from 'src/config-global';
import FoodItemDiscussion from 'src/sections/home/library-food-item-discussion';

// ----------------------------------------------------------------------

const metadata = { title: `Food  Discussion |  ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <FoodItemDiscussion />
    </>
  );
}
